import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { getCategories, getCategoryQuestions } from '../data';
import {
    gettingBrowsedAction,
    gotBrowsedAction,
    AppState,
    gettingCategoriesAction,
    gotCategoriesAction,
} from '../Store';

import { Title } from '../components/Title';
import { QuestionList } from '../components/QuestionList';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Container, Typography, Breadcrumbs, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        link: {
            display: 'flex',
            cursor: 'pointer',
        },
        icon: {
            marginRight: theme.spacing(0.5),
            width: 20,
            height: 20,
        },
    })
);

export const Category = () => {
    const classes = useStyles();

    const dispatch = useDispatch();
    const loading = useSelector((state: AppState) => state.questions.loading);
    const categories = useSelector((state: AppState) => state.questions.categories);
    const questions = useSelector((state: AppState) => state.questions.browsed);

    const { id } = useParams();
    const categoryId = parseInt(id);
    const category = categories.filter((category) => category.categoryId === categoryId)[0];

    const fetchQuestions = async () => {
        dispatch(gettingBrowsedAction());
        const fetchedQuestions = await getCategoryQuestions(categoryId);
        dispatch(gotBrowsedAction(fetchedQuestions));
    };

    const fetchCategories = async () => {
        dispatch(gettingCategoriesAction());
        const fetchedCategories = await getCategories();
        dispatch(gotCategoriesAction(fetchedCategories));
    };

    useEffect(() => {
        fetchQuestions();
        fetchCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const navigate = useNavigate();

    return (
        <>
            {category && <Title title={category.name} />}

            <Container maxWidth="lg">
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{
                        paddingTop: '20px',
                    }}
                >
                    <Link
                        color="inherit"
                        onClick={() => {
                            navigate('/');
                        }}
                        className={classes.link}
                    >
                        <HomeIcon className={classes.icon} />
                        Home
                    </Link>
                    <Typography>{category && category.name}</Typography>
                </Breadcrumbs>

                <Typography variant="h5" align="center" sx={{ padding: 2 }}>
                    {category && category.name}
                </Typography>
                {!loading && <QuestionList data={questions} showCategory={false} showLabels={true} />}
            </Container>
        </>
    );
};
